import axios from 'axios';

export async function addChesterUpdateNote(propertyId: number, additionalInformation: string) {
  const { data: property } = await axios.get(`/api/Property/getProperty/${propertyId}`);
  return addChesterUpdateNoteWithProperty(property, additionalInformation);
}

export function addChesterUpdateNoteWithProperty(property: any, additionalInformation: string) {
  const noteText = 'Note: Any update requires a $100 update fee with a new request';
  if (
    property.county === 'Warren' ||
    property.municipality !== 'Chester' ||
    property.subMunicipality ||
    additionalInformation.includes(noteText)
  ) {
    return additionalInformation;
  }
  const newLine = additionalInformation ? '\n' : '';
  return `${additionalInformation || ''}${newLine}${noteText}`;
}
